import axiosClient from './axiosClient';
const ChuGiaiApi = {

    getThoNhuong: () => {
        const url = 'chugiai/thonhuong';
        return axiosClient.get(url)
    },
    getAllDvdd: () => {
        const url = 'chugiai/getalldvdd';
        return axiosClient.get(url)
    },
    getDeXuat: () => {
        const url = 'chugiai/dexuat';
        return axiosClient.get(url)
    },
    getThichHop: () => {
        const url = 'chugiai/thichhop';
        return axiosClient.get(url)
    },
    getChatLuongDat: () => {
        const url = 'chugiai/chatluongdat';
        return axiosClient.get(url)
    },
    getHienTrang: () => {
        const url = 'chugiai/hientrang';
        return axiosClient.get(url)
    }
}
export default ChuGiaiApi;